import styled from "styled-components";

export const ButtonsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: auto;
  width: 500px;
  height: 100px;
`;

export const ButtonContainer = styled.div`
  width: 250px;
`;
